import { unescape } from 'lodash';

/**
 * r101-api will html-escape the titles of chat streams.
 * This was done in order to fix an XSS vulnerability that
 * was reported(check https://github.com/remind101/r101-api/pull/16486 for
 * for details).
 * This means special html characters in chat titles, like single quotes
 * will be escaped in the v1 and v2 endpoints that return
 * chat titles.
 * In order to display these titles correctly we need to unescape
 * them first. Showing text in React in the "normal" is safe againt
 * these types of injection attacks, so doing something like:
 * <Text>
 *   {unescapeTitle(chat.title)}
 * </Text>
 * is safe for us to do.
 * Chat titles should be unescaped in the places where they're actually
 * displayed, and we should always verify that the usages are actually safe.
 * Lodash's unescape function is used for this, because it
 * unescapes the same characters that are escaped by r101-api
 */
export function unescapeTitle(chatTitle: string) {
  return unescape(chatTitle);
}
